import './css/styles.scss';

function startbildStartsidaInit() {}

startbildStartsidaInit();
